import { call, getContext, put, takeLatest } from "redux-saga/effects";

import { CONTEXT } from "@const/redux";
import { getCardDetailsActionTypes } from "./actionTypes";
import { getCardDetailsSuccess, getCardDetailsFailure } from "./actions";
import ToastService from "../../services/ToastService";

const getCardDetailsAsync = ({ CardsService, id }) => {
  if (!CardsService) {
    console.log("Required service is missing");
    return;
  }

  return CardsService.getCardDetails(id);
};

export function* getCardDetails({ payload }) {
  try {
    const { id } = payload;
    const { CardsService } = yield getContext(CONTEXT.SERVICES);

    const { data } = yield call(getCardDetailsAsync, { CardsService, id });

    yield put(getCardDetailsSuccess(data));
  } catch ({ error }) {
    yield put(getCardDetailsFailure());
    ToastService.error(error?.message);
  }
}

export function* watchGetCardDetails() {
  yield takeLatest(getCardDetailsActionTypes.request, getCardDetails);
}
